import dynamic from "next/dynamic";
import SideBySideWithParagraphsParagraphConfig from "./side-by-side-with-paragraphs-paragraph-config";
import SideBySideWithParagraphsParagraphAdvancedConfig from "./side-by-side-with-paragraphs-paragraph-advanced-config";
const SideBySideWithParagraphsParagraphComponent = dynamic(()=>import("./side-by-side-with-paragraphs-paragraph-component"));
export default {
    SideBySideWithParagraphsParagraphComponent,
    SideBySideWithParagraphsParagraphConfig,
    SideBySideWithParagraphsParagraphAdvancedConfig
};
